import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.OtherSelection;

export const typologiesStatusSelector = createSelector(rootSelector, (state) => state.typologies.status);

export const typologiesErrorSelector = createSelector(rootSelector, (state) => state.typologies.error);

const typologiesSelector = createSelector(rootSelector, (state) => state.typologies.data);

export const conflictTypesStatusSelector = createSelector(rootSelector, (state) => state.conflictTypes.status);

export const conflictTypesErrorSelector = createSelector(rootSelector, (state) => state.conflictTypes.error);

const conflictTypesSelector = createSelector(rootSelector, (state) => state.conflictTypes.data);

export default {
  typologiesStatusSelector,
  typologiesErrorSelector,
  typologiesSelector,
  conflictTypesSelector,
  conflictTypesErrorSelector,
  conflictTypesStatusSelector,
};
